import { ThemeAPI } from 'nuvo-react';
import { I18nCnxSupportedLanguage } from '../types';

export const NUVO_DATE_REGEX = '^\\d{4}-\\d{2}-\\d{2} \\d{2}:\\d{2}$';
export const NUVO_DATE_FORMAT = 'yyyy-MM-dd HH:mm';

export const NUVO_STYLE: ThemeAPI = {
  buttons: {
    primary: {
      backgroundColor: 'black',
      color: '#fff',
      ':hover': {
        backgroundColor: 'grey',
      },
    },
    import: {
      backgroundColor: '#078850',
      color: '#ffffff',
      border: 0,
      borderRadius: '4px',
      ':hover': {
        backgroundColor: '#045230',
        borderColor: '#045230',
      },
      ':active': {
        backgroundColor: '#045230',
        borderColor: '#045230',
      },
    },
  },
  messagePopup: {
    description: {
      padding: '25px',
      textAlign: 'left',
      whiteSpace: 'pre-wrap',
    },
  },
};

export const NUVO_SUCCESS_MODAL_DURATION = 3000;
export const NUVO_SUCCESS_MODAL_WITH_FAILURES_DURATION = 60000; // NOTE: 10 minutes, let the user read error messages

export const NUVO_TRANSLATIONS = {
  [I18nCnxSupportedLanguage.en]: {},
  [I18nCnxSupportedLanguage.de]: {
    txt_upload_data: 'Hochladen',
    txt_allow_data_type: 'Datei zum Hochladen hierher ziehen',
    txt_select_files: 'Datei auswählen',
    txt_select_option: 'Wähle eine Option',
    txt_back: 'Zurück',
    txt_continue: 'Weiter',
    txt_cancel: 'Abbrechen',
    txt_sheet_selection: 'Tabellenblattauswahl',
    txt_sheet_selection_description:
      'Es muss das Tabellenblatt der Datei ausgewählt werden, das importiert werden soll.',
    txt_select_header: 'Kopfzeilenauswahl',
    txt_download_template: 'Vorlage herunterladen',
    txt_download_template_desc:
      'Es besteht die Möglichkeit, die vorhandene Datei über "{{button_name}}" hochzuladen. Wenn bevorzugt wird, mit einer Vorlage zu arbeiten, kann diese unten als Excel oder CSV heruntergeladen werden.',
    txt_download_excel: 'Excel - Vorlage (.xlsx)',
    txt_download_excel_modal: 'Excel (.xlsx)',
    txt_download_csv: 'CSV - Vorlage',
    txt_download_csv_modal: 'CSV',
    txt_all: 'Alle',
    txt_select: 'Auswählen',
    txt_export_as_excel: 'Exportieren als Excel',
    txt_title_submit_success:
      'Herzlichen Glückwunsch, die Daten wurden erfolgreich hochgeladen.',
    txt_example: 'Bsp.',
    txt_title_confirm_submit_data_without_error: 'Bereit zum Abschicken?',
    txt_confirm_submit_data_with_error:
      'Sicher, dass die Daten abgeschickt werden sollen? Zeilen mit einem Fehler werden nicht importiert. Wenn ja, bitte den "Senden"-Button klicken. Andernfalls den "Zurück"-Button nutzen',
    txt_confirm_submit_data_without_error:
      'Sicher, dass die Daten abgeschickt werden sollen?  Wenn ja, bitte den "Senden"-Button klicken. Andernfalls den "Zurück"-Button nutzen',
    txt_allow_error_confirm_submit_data_with_error:
      'Sicher, dass die Daten abgeschickt werden sollen?  Zeilen mit einem Fehler werden ebenfalls importiert. Wenn ja, bitte den "Senden"-Button klicken. Andernfalls den "Zurück"-Button nutzen',
    txt_import_data_error_exceed:
      'Der Import führte zu {{error}} Fehlern. Wenn diese Fehler später in der Anwendung korrigiert werden sollen, bitte den "Weiter"-Button drücken. Andernfalls kann die Tabelle mit Klick auf den „Exportieren als Excel“-Button als Excel Datei (.xlsx) heruntergeladen werden.',
    txt_field_required: 'Erforderlich',
    txt_field_category_required: 'Option auswählen',
    txt_field_invalid_format_number: 'Zahl erforderlich',
    txt_field_invalid_format_number_int: 'Keine Dezimalzahlen erlaubt',
    txt_field_invalid_format_number_float: 'Zahl erforderlich',
    txt_field_not_in_options: 'Es muss eine Option ausgewählt werden',
    txt_field_invalid_regex_format: 'Ungültiges Format',
    txt_field_unique: 'Eindeutiger Wert erforderlich',
    txt_field_required_with:
      'Dieses Feld ist erforderlich, wenn eines der folgenden Felder ausgefüllt ist: {{columns}}',
    txt_field_required_without:
      'Dieses Feld ist erforderlich, wenn eines der folgenden Felder leer ist: {{columns}}',
    txt_field_required_with_all:
      'Dieses Feld ist erforderlich, wenn alle der folgenden Felder ausgefüllt sind: {{columns}}',
    txt_field_required_without_all:
      'Dieses Feld ist erforderlich, wenn alle der folgenden Felder leer sind: {{columns}}',
    txt_field_required_with_values:
      'Dieses Feld ist erforderlich, wenn eines der folgenden Felder folgende Werte hat: {{columns}}',
    txt_field_required_without_values:
      'Dieses Feld ist erforderlich, wenn eines der folgenden Felder diese Werte nicht enthält: {{columns}}',
    txt_field_required_with_all_values:
      'Dieses Feld ist erforderlich, wenn alle der folgenden Felder folgende Werte haben: {{columns}}',
    txt_field_required_without_all_values:
      'Dieses Feld ist erforderlich, wenn alle der folgenden Felder diese Werte nicht haben: {{columns}}',
    txt_close: 'Schließen',
    txt_data_processing: 'Daten werden verarbeitet...',
    txt_back_page_dialog:
      'Mit Klick auf den "Zurück"-Button gehen alle Eingaben in diesem Schritt verloren.',
    txt_close_page_dialog:
      'Mit Klick auf den "Zurück"-Button gehen alle Eingaben verloren.',
    txt_title_sheet_max_entries: 'Zu viele Zeilen',
    txt_desc_sheet_max_entries:
      'Die maximale Anzahl an Zeilen für den Import beträgt {{maxEntries}}. Wenn die Datei zu groß ist, muss diese vor dem Hochalden in 2 Dateien aufgeteilt werden.',
    txt_dialog_un_matched:
      'Die folgenden Spalten müssen noch verknüpft werden: {{unMatched}}',
    txt_or: 'oder',
    txt_progress_upload: 'Hochladen',
    txt_progress_sheet_selection: 'Tabellenblattauswahl',
    txt_progress_header_selection: 'Kopfzeilenauswahl',
    txt_progress_match_column: 'Spaltenmapping',
    txt_progress_review_entries: 'Import prüfen',
    txt_confirm_title: 'Import abschließen?',
    txt_massive_error: 'Massiver Fehler',
    txt_match_column_required:
      'Erforderliche Spalte(n) müssen verknüpft werden.',
    txt_submit_understand: 'Schließen',
    txt_go_back: 'Zurück',
    txt_submit: 'Senden',
    txt_title_too_many_files_error: 'Bitte nur eine Datei auswählen',
    txt_too_many_files_error:
      'Derzeit wird das Hochladen von mehreren Dateien nicht unterstützt. Bitte nur eine Datei hochladen.',
    txt_title_upload_valid_file_error: 'Ungültige Datei',
    txt_upload_valid_file_error:
      'Bitte Datei in einem gültigen Format auswählen. .csv, .tsv, .xls und .xlsx-Dateien werden akzeptiert.',
    txt_page_upload_desc:
      'Datei hier via Drag & Drop ablegen oder Datei hochladen.',
    txt_select_header_desc:
      'Bitte die Headerzeile des Tabellenblattes auswählen oder bestätigen.',
    txt_num_sheet_other: '{{count}} Tabellenblätter',
    txt_sheet_selection_title:
      'Es kann kein Tabellenblatt mit mehr als {{maxentries}} Zeilen ausgewählt werden.',
    txt_size_import_one: '{{count}} Tabellenblatt importiert.',
    txt_size_import_other: '{{count}} Tabellenblätter importiert.',
    txt_delete_button: 'Löschen',
    txt_duplicate_button: 'Duplikat',
    txt_find_error: 'Fehler finden',
    txt_toggle_error: 'Nur Zeilen mit Fehler anzeigen',
    txt_one_error: '1 Fehler',
    txt_error_amount: '{{amountOfErrors}} Fehler',
    txt_confirm: 'Bestätigen',
    txt_upload_file: 'Daten werden hochgeladen...',
    txt_require_columns: 'Erforderliche Spalten',
    txt_show_more: 'Mehr anzeigen',
    txt_show_less: 'Weniger anzeigen',
    txt_search: 'Suche',
    txt_required: 'Erforderlich',
    txt_not_all_mapped: 'Nicht alle Werte wurden verknüpft',
    txt_empty: 'leer',
    txt_unable_match_auto: 'Keine automatische Verknüpfung möglich',
    txt_match_manual: 'Verknüpft mit',
    txt_match_auto: 'Automatisch verknüpft',
    txt_unable_match: 'Nicht verknüpft',
    txt_recommended_match: 'Empfohlene Verknüpfung',
    txt_others: 'Andere',
    txt_percent_row_have_values: '{{percent}} der Zeilen enthalten Daten',
    txt_full_screen: 'Vollbild',
    txt_default_sheet_name: 'CSV Import',
    txt_search_result: 'Suchergebnis',
    txt_title_warning_screen: 'Die Bildschirmbreite ist zu klein',
    txt_warning_screen:
      'Bitte ein anderes Gerät verwenden oder die Bildschirmbreite erhöhen, um die Daten zu importieren',
    txt_title_warning_screen_modal_false: 'Breite der Komponente ist zu klein',
    txt_warning_screen_modal_false:
      'Bitte ein anderes Gerät verwenden oder die Bildschirm- oder Komponentenbreite erhöhen, um die Daten zu importieren',
    txt_complete_imports: 'Import abschließen',
    txt_no_data_in_sheet_title: 'Die hochgeladene Datei ist leer',
    txt_no_data_in_sheet_description:
      'Es muss eine Datei hochgeladen werden, welche Daten enthält.',
    txt_not_export_file:
      'Diese Funktion ist deaktiviert, da mehr als 100.000 Zeilen importiert wurden.',
    txt_allow_multiple_data_type: 'Dateien hier ablegen',
    txt_allow_multiple_select_files: 'Dateien auswählen',
    txt_multiple_sheet_selection_description:
      'Ein oder mehrere Tabellenblätter müssen für den Import ausgewählt werden. Wenn mehrere Tabellenblätter ausgewählt werden, müssen alle ausgewählten Tabellenblätter eine Spalte mit einem Key enthalten, damit sie im Importprozess zusammengefügt werden können.',
    txt_page_multiple_upload_desc:
      'Dateien hier vie Drag & Drop ablegen oder Dateien zum Hochladen auswählen.',
    txt_num_one_sheet_other: '{{count}} Tabellenblatt',
    txt_size_multi_import_one: '{{sheet}} Tabellenblatt importiert.',
    txt_size_multi_import_other: '{{sheet}} Tabellenblätter importiert.',
    txt_allow_multiple_upload_file: 'Daten werden hochgeladen...',
    txt_progress_join_column: 'Tabellenblätter zusammenfügen',
    txt_add_files: 'Weitere Datei hochladen',
    txt_progress_bar: '{{step}} aus {{size}} Tabellenblättern',
    txt_joined: 'Zusammengefügt',
    txt_joined_columns: 'Verbundene Spalten',
    txt_maximum_selected_sheet: 'Zu viele Tabellenblätter ausgewählt',
    txt_joined_columns_description:
      '{{sheet}} Tabellenblätter werden von den folgenden Schlüsselspalten verbunden. Die Daten dieser Schlüsselspalten werden in einer gemeinsamen Spalte importiert.',
    txt_maximum_selected_sheet_desc:
      'Es können maximal {{size}} Tabellenblätter ausgewählt werden.',
    txt_accept_understand: 'Verstanden',
    txt_sheet_selection_list_title: 'Alle ausgewählt',
    txt_sheet_selection_multiple_desc:
      'Sie haben {{amount}} Tabellenblätter ausgewählt',
    txt_sheet_selection_one_desc:
      'Sie haben {{amount}} Tabellenblatt ausgewählt',
    txt_join_sheets: 'Tabellenblätter zusammenfügen',
    txt_join_sheets_desc:
      'Es muss für jedes Tabellenblatt eine Schlüsselspalte ausgewählt werden, die Daten enthält, die in jedem Tabellenblatt gleich sind und zum Zusammenfügen der Tabellenblätter verwendet werden können.',
    txt_join_sheets_percent_matched: '{{percent}}% Übereinstimmung',
    txt_join_sheets_percent_not_matched:
      'Es können keine Einträge zusammengefügt werden',
    txt_title_warning_join_column: 'Auswahl der Schlüsselspalte erforderlich',
    txt_desc_warning_join_column:
      'Es muss eine Schlüsselspalte für jedes Tabellenblatt ausgewählt werden, um die Tabellenblätter zusammenzufügen und den Import fortzusetzen.',
    txt_submit_i_understand: 'Verstanden',
    txt_match_percent_description:
      'mit <strong>{{columnKey}}</strong> in <strong> {{name}} </strong> - <strong> {{fileName}} </strong>',
    txt_title_warning_join_column_order:
      'Auswahl der Schlüsselspalten erforderlich',
    txt_desc_warning_join_column_order:
      'Es muss eine Schlüsselspalte für <strong> {{sheetName}} </strong> - {{fileName}} ausgewählt werden',
    txt_no_matching_entry_title:
      'Einträge in den Schlüsselspalten stimmen nicht überein',
    txt_no_matching_entry_description_multiple:
      'In mindestens einem Tabellenblatt stimmen die Einträge der ausgewählten Schlüsselspalte nicht mit den Einträgen der anderen Tabellenblätter überein. Es muss eine andere Schlüsselspalte ausgewählt werden oder die Tabellenblätter müssen separat hochgeladen werden.',
    txt_no_matching_entry_description_single:
      'In mindestens einem Tabellenblatt stimmen die Einträge der ausgewählten Schlüsselspalte nicht mit den Einträgen des anderen Tabellenblattes überein. Es muss eine andere Schlüsselspalte ausgewählt werden oder die Tabellenblätter müssen separat hochgeladen werden.',
    txt_upload_exceed_max_size_error:
      'Die ausgewählte Datei ist größer als {{sizeInMb}}MB',
    txt_title_upload_exceed_max_size_error: 'Maximale Dateigröße überschritten',
    txt_manual_entry: 'Manuelle Eingabe',
    txt_just_a_moment_please: 'Einen kleinen Moment bitte',
    txt_validating: 'Daten werden validiert...',
    txt_file_error:
      'Es gibt ein Problem bei der Verarbeitung der importierten Daten.',
    txt_dropdown_options: 'Dropdown Optionen',
    txt_positive_button_close_modal: 'Geh zurück',
    txt_negative_button_close_modal: 'Absagen',
    txt_invalid_data_behavior_block_more_error:
      'Ihre Daten enthalten {{errorCount}} Formatfehler, die behoben werden müssen.',
    txt_invalid_data_behavior_block:
      'Ihre Daten enthalten {{errorCount}} Formatfehler, die behoben werden müssen.',
    txt_confirm_title_close_modal: 'Sind Sie sicher?',
    txt_field_invalid_date_dmy:
      'Die Eingabe ist ungültig. Bitte geben Sie ein Datum im folgenden Format ein: dd.mm.yyyyy, z. 14.01.2022',
    txt_field_invalid_date_mdy:
      'Die Eingabe ist ungültig. Bitte geben Sie ein Datum im folgenden Format ein: mm.dd.yyyy, z. 12.31.2022',
    txt_field_invalid_date_ymd:
      'Die Eingabe ist ungültig. Bitte geben Sie ein Datum im folgenden Format ein: yjyy.mm.dd, z. 2022.12.31',
    txt_invalid_format_date_iso:
      'Die Eingabe ist ungültig. Bitte geben Sie ein Datum im folgenden Format ein: yjyy-mm-dd, z. 2022-01-31',
    txt_invalid_format_datetime:
      'Die Eingabe ist ungültig. Bitte geben Sie eine DateTime im folgenden Format ein: yyyy-mm-dd hh: mm: ss, z. 2022-01-01 00:01:10',
    txt_invalid_format_time_hms:
      'Die Eingabe ist ungültig. Bitte geben Sie eine Zeit im folgenden Format ein: HH: MM: SS (12 -Stunden -Format), z. 01:01:10 am',
    txt_invalid_format_time_hms_24:
      'Die Eingabe ist ungültig. Bitte geben Sie eine Zeit im folgenden Format ein: HH: MM: SS (24H -Format), z. 23:01:10',
    txt_invalid_format_time_hm:
      'Die Eingabe ist ungültig. Bitte geben Sie eine Zeit im folgenden Format ein: HH: mm (12 -Stunden -Format), z. 10:01 am',
    txt_invalid_format_time_hm_24:
      'Die Eingabe ist ungültig. Bitte geben Sie eine Zeit im folgenden Format ein: HH: MM (24H -Format), z. 23:01',
    txt_invalid_format_email:
      'Die Eingabe ist ungültig. Bitte geben Sie eine gültige E -Mail -Adresse ein, z. max@company.com',
    txt_invalid_format_url_www:
      'Die Eingabe ist ungültig. Bitte geben Sie eine URL im folgenden Format an: www.example.com',
    txt_invalid_format_url_https:
      'Die Eingabe ist ungültig. Bitte geben Sie eine URL im folgenden Format an: https://example.com',
    txt_invalid_format_url:
      'Die Eingabe ist ungültig. Bitte geben Sie eine URL im folgenden Format an: example.com',
    txt_invalid_format_phone:
      'Die Eingabe ist ungültig. Die Telefonnummer muss mit 00 oder +beginnen.',
    txt_invalid_format_zip_code_de:
      'Die Eingabe ist ungültig. Bitte geben Sie im folgenden Format eine gültige Deutsche oder österreichische Postleitzahl an: 20095',
    txt_invalid_format_percentage:
      'Die Eingabe ist ungültig. Bitte geben Sie im folgenden Format einen prozentualen Wert mit oder ohne % Anmelden ein: 12 %, 12 oder 12,8',
    txt_invalid_format_currency_eur:
      'Die Eingabe ist ungültig. Bitte geben Sie einen Wert im folgenden Format ein: 40,00 EUR, 42,50€ oder 45,22',
    txt_invalid_format_currency_usd:
      'Die Eingabe ist ungültig. Bitte geben Sie einen Wert im folgenden Format ein: 40,00 USD, 42,50$, USD 35,09 oder $45,22',
    txt_invalid_format_bic:
      'Die Eingabe ist ungültig. Bitte geben Sie im folgenden Format einen BIC an: COBADEFFXXX',
    txt_invalid_format_vat_eu:
      'Die Eingabe ist ungültig. Bitte geben Sie eine gültige europäische Mehrwertsteuernummer an. Z.B. DE123456789 oder ATU12345678',
    txt_invalid_format_gtin:
      'Die Eingabe ist ungültig. Bitte geben Sie eine gültigen GTIN mit 8, 12, 13 oder 14 Ziffern an.',
    txt_invalid_format_iban:
      'Die Eingabe ist ungültig. Bitte geben Sie im folgenden Format einen Iban ohne Rohlinge an: DE89370400440532013000',
    txt_loading: 'Wird geladen...',
    txt_create_new_option: 'Neue Option erstellen',
    txt_custom_column_description: 'Diese Spalte wurde von Ihnen erstellt',
    txt_create_new_column: 'Neue Zielspalte erstellen',
    txt_default_sheet_prefix_name: 'Tabellenblatt',
    txt_file_format_error:
      'Das Dateiformat ist ungültig. Bitte laden Sie eine gültige .csv, .tsv, .xls, .xlsx, .json oder .xml -Datei hoch.',
    txt_option_custom_created_info:
      'Diese Dropdown Option wurde von Ihnen für diesen Import erstellt.',
    txt_default_title_error: 'Etwas ist schief gelaufen',
    txt_import_error: 'Fehler beim Import.',
    txt_title_error_invalid_format: 'Ungültiges Format',
    txt_create_custom_not_allowed:
      'Sie können keine neue Spalte erstellen, wenn der Titel nur Sonderzeichen und Leerzeichen enthält.',
    txt_add_new_row: 'Neue Zeile hinzufügen',
    txt_download_only_csv_template_desc:
      'Sie können Ihre vorhandene Datei über "{{button_name}}" hochzuladen. Wenn Sie jedoch lieber mit einem Template arbeiten, finden Sie den CSV-Download für das Template unten.',
    txt_title_info_box_automatic_mapping: 'Spalten wurden automatisch gemappt.',
    txt_description_info_box_automatic_mapping:
      'Wenn Sie einige Ihrer importierten Daten vermissen oder Daten einer falschen Spalte zugeordnet wurden, drücken Sie bitte den "Zurück"-Button, um das Spaltenmapping zu korrigieren.',
    txt_multiselection_allowed: 'Mehrfachauswahl erlaubt',
    txt_successful_records: '{{amount}} erfolgreiche Datensätze',
    txt_failed_records: '{{amount}} fehlgeschlagene Datensätze',
    txt_import_data: 'Daten importieren',
    txt_edit_data_button: 'Daten bearbeiten',
    txt_description_submit_success: 'Ihre Daten wurden erfolgreich importiert.',
  },
};
